/* This is updated by the Jenkins script to reflect
   the value of the sha commit
   @see JenkinsFile
 */
export const commit_sha : string = 'COMMIT_SHA';
